import { ClipboardList, NotebookPen, Building2 } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminReferrals } from "@/components/admin/AdminReferrals";
import { ReportNotes } from "@/components/admin/ReportNotes";
import { AdminCompanies } from "@/components/admin/AdminCompanies";
import { AdminPlans } from "@/components/admin/AdminPlans";

export default function Admin() {
  return (
    <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:py-12" data-testid="admin-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F2D5E]">Pannello amministratore</p>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">Gestione</h1>
      <Tabs defaultValue="segnalazioni" className="mt-8">
        <TabsList className="grid h-auto w-full grid-cols-3 rounded-full bg-[#F4F5F0] p-1 sm:inline-grid sm:w-auto">
          <TabsTrigger value="segnalazioni" className="h-10 rounded-full px-2 text-xs data-[state=active]:bg-white data-[state=active]:text-[#0F2D5E] sm:px-5 sm:text-sm" data-testid="tab-segnalazioni">
            <ClipboardList className="mr-2 hidden h-4 w-4 sm:block" /> Segnalazioni
          </TabsTrigger>
          <TabsTrigger value="aziende" className="h-10 rounded-full px-2 text-xs data-[state=active]:bg-white data-[state=active]:text-[#0F2D5E] sm:px-5 sm:text-sm" data-testid="tab-aziende">
            <Building2 className="mr-2 hidden h-4 w-4 sm:block" /> Aziende
          </TabsTrigger>
          <TabsTrigger value="report" className="h-10 rounded-full px-2 text-xs data-[state=active]:bg-white data-[state=active]:text-[#0F2D5E] sm:px-5 sm:text-sm" data-testid="tab-report">
            <NotebookPen className="mr-2 hidden h-4 w-4 sm:block" /> Report & Note
          </TabsTrigger>
        </TabsList>
        <TabsContent value="segnalazioni" className="mt-8"><AdminReferrals /></TabsContent>
        <TabsContent value="aziende" className="mt-8 space-y-14"><AdminPlans /><AdminCompanies /></TabsContent>
        <TabsContent value="report" className="mt-8"><ReportNotes /></TabsContent>
      </Tabs>
    </main>
  );
}
